import React from "react";
import Service_Banner from "../service_common_components/service_banner/Service_Banner";
import Service_Content from "../service_common_components/service_content/Service_Content";
import Service_Specification from "../service_common_components/service_specification/Service_Specification";
import Key_Elements from "../service_common_components/key_elements/Key_Elements";
import Get_Quote from "../service_common_components/get_quote/Get_Quote";

const Home_Automation = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Home Automation  ", link: "", isActive: true },
  ];

  const contentText = [
    "Step into the future with our home automation solutions. We integrate technology into your  interiors with smart lighting, motion sensors, climate control, voice-controlled devices,  and security systems. ",
    "We make homes smarter, safer, and more convenient, giving you complete control at your  fingertips.  ",
  ];

  const spcifications = [
    {
      img: "/assets/images/services/specifications/img1.png",
      titleText: "Space Optimization",
      subText: "Through the best smart space optimization interior design.",
    },
    {
      img: "/assets/images/services/specifications/img2.png",
      titleText: "Flexible Layouts",
      subText:
        "Flexible layouts for seamless with the new functionality & style.",
    },
    {
      img: "/assets/images/services/specifications/img3.png",
      titleText: "Smart Technology",
      subText: "Integrating smart technology to enhance and efficiency.",
    },
    {
      img: "/assets/images/services/specifications/img4.png",
      titleText: "Cost Efficiency",
      subText:
        "Achieving and functional interiors cost-efficient design solutions.",
    },
  ];

  const keyElements = [
    "We provide high quality design services.",
    "Project on time and Latest Design.",
    "Scientific Skills For getting a better result.",
    "Flexible with any structure of the building",
    "Commitment to customer service",
    "Experienced, time-served engineers",
    "We are confident about our projects.",
  ];

  return (
    <div>
      <Service_Banner
        imgSrc={"/assets/images/services/banners/residential.png"}
        title_text="SERVICES"
        breadcrumbs={breadcrumbs}
      />

      <Service_Content
        titleText="Home Automation "
        contentText={contentText}
        imgSrc="/assets/images/home/our_services/clients_images/home.jpeg"
      />

      <Service_Specification
        spcifications={spcifications}
        specifictaionDescn="In design, we bring characteristics of the natural world into built spaces, such as water, greenery, and natural light, or elements like wood and stone. Encouraging the use of natural systems and processes in design allows for exposure to nature, and in turn, these design approaches improve health and wellbeing. There are a number of possible benefits, including reduced heart rate variability and pulse rates, decreased blood pressure, and increased activity in our nervous systems, to name a few."
      />

      <Key_Elements
        imgSrc1={"/assets/images/services/key_elements/commercial/img1.png"}
        imgSrc2={"/assets/images/services/key_elements/commercial/img2.png"}
        boxText="Key Elements"
        subText=" of Home Automation "
        keyElements={keyElements}
      />

      <Get_Quote quotetext="We partner with our clients to develop unique design projects tailored to their specific needs. Our approach focuses on bringing their individual ideas and processes to life, rather than relying on one-size-fits-all solutions." />
    </div>
  );
};

export default Home_Automation;
